import { formatDate } from 'legacy/utils/date/formatDate'
import { DATE_FORMAT_STOP_LFD_VESSEL_CUT } from 'legacy/utils/intermodal'

import { type LoadIntermodal } from '../domain/LoadIntermodal'
import { type LoadStop } from '../domain/LoadStop'

export type StopInfo = {
  label: string
  location: string
  appointment?: string
}

function intermodalDateFormat(date?: Date): string {
  return date ? formatDate(date, DATE_FORMAT_STOP_LFD_VESSEL_CUT) : 'N/A'
}

export function getStopInfo(stop: LoadStop, intermodal?: LoadIntermodal): StopInfo {
  const { confirmed, stopIndex } = stop
  const location = `${stop.city.toLowerCase()}, ${stop.state.toUpperCase()}`
  const pickup = { label: 'Pickup', location }
  const delivery = { label: 'Delivery', location }

  if (intermodal?.container) {
    const { loadType, lastFreeDayAtPort, vesselEtaDate, vesselCutoffDate, portName } =
      intermodal.container

    const isImport = loadType === 'load_import'
    const isExport = loadType === 'load_export'

    if (isImport && stopIndex === 0) {
      return {
        ...pickup,
        location: portName,
        appointment: intermodalDateFormat(lastFreeDayAtPort ?? vesselEtaDate),
      }
    }

    if (isImport && stopIndex === 1) {
      return {
        ...delivery,
        appointment: confirmed ? undefined : 'APPT Pending',
      }
    }

    if (isExport && stopIndex === 1) {
      return {
        ...pickup,
        appointment: confirmed ? undefined : 'APPT Pending',
      }
    }

    if (isExport && stopIndex === 3) {
      return {
        ...delivery,
        location: portName,
        appointment: intermodalDateFormat(vesselCutoffDate ?? vesselEtaDate),
      }
    }
  }

  if (stop.type === 'pickup') {
    return pickup
  }

  if (stop.type === 'delivery') {
    return delivery
  }

  if (stopIndex === 0) {
    return pickup
  }

  if (stopIndex > 0) {
    return delivery
  }

  return {
    label: 'Not Found',
    location,
  }
}
